// Trade-marker helpers shared by the symbol chart (Charts page) and the balance
// history chart (Dashboard).

// The first bar on or after `date` — where an event dated on a non-trading day
// (weekend, holiday) is drawn. Undefined if the date is past the last bar.
export const barOnOrAfter = (bars, date) => bars.find(b => b.time >= date);

// Buys and sells grouped per bar and type, one marker each. A trade snaps to the
// first bar on or after its date (covers dates with no bar, e.g. holidays);
// trades outside the loaded bar range are dropped. The marker sits at the
// share-weighted average price of the group.
export function groupTrades(transactions, bars) {
  if (!bars.length) return [];
  const first = bars[0].time;
  const groups = new Map();
  transactions.forEach(t => {
    if ((t.transaction_type !== 'buy' && t.transaction_type !== 'sell') || t.date < first) return;
    const bar = bars.find(b => b.time >= t.date);
    if (!bar) return;
    const id = `${bar.time}:${t.transaction_type}`;
    if (!groups.has(id)) groups.set(id, { id, time: bar.time, type: t.transaction_type, quantity: 0, cost: 0, trades: [] });
    const g = groups.get(id);
    g.quantity += t.quantity;
    g.cost += t.quantity * t.price_per_share;
    g.trades.push(t);
  });
  return [...groups.values()]
    .map(g => ({ ...g, price: g.quantity > 0 ? g.cost / g.quantity : g.trades[0].price_per_share }))
    .sort((a, b) => (a.time < b.time ? -1 : a.time > b.time ? 1 : 0));
}

// Mirrors lightweight-charts' marker sizing (clamped bar spacing) so the hover
// highlight fits around the arrow.
export const markerSize = barSpacing => Math.min(Math.max(barSpacing, 12), 30);
